define('shoptheme/components/ui/toggle-visibility',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-affix"
], function(
	$,
	Component,
	BEM
) {

	return Component.create({

		blocks: null,

		$init: function() {
			this.blocks = $('[data-toggle-visibility]');
			this.blocks.each(function() {
				var state = 0,
					button = $(this),
					showMore = button.html(),
					showLess = button.data('toggle-less-text'),
					container = $(button.data('toggle-visibility')),
					targetElements = container.find(button.data('toggle-visibility-elements'));

				button.click( function(e){
					if (!state) {
						e.preventDefault();
						targetElements.show();
						button.html(showLess);
						state = 1;
					} else {
						e.preventDefault();
						targetElements.hide();
						button.html(showMore);
						state = 0;
					}
				});
			});

		}

	});

});

